import { render, staticRenderFns } from "./addLocation.vue?vue&type=template&id=03bf3364&scoped=true"
import script from "./addLocation.vue?vue&type=script&lang=js"
export * from "./addLocation.vue?vue&type=script&lang=js"
import style0 from "./addLocation.vue?vue&type=style&index=0&id=03bf3364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf3364",
  null
  
)

export default component.exports